import { DynamicFieldData } from '@/shared/components/DynamicForm/models/DynamicFieldData'
import { DynamicFormDefinition } from '@/shared/components/DynamicForm/models/DynamicFormSection'

type GetConstraintFormDefinitionArgs = {
  formType: 'add' | 'edit' | 'view'
  showOrderAttribute?: boolean
  showVehicleAttribute?: boolean
  showCompatible?: boolean
}

export const getConstraintFormDefinition = ({
  formType,
  showOrderAttribute = true,
  showVehicleAttribute = true,
  showCompatible = true,
}: GetConstraintFormDefinitionArgs): DynamicFormDefinition => {
  const fields: DynamicFieldData[] = []

  // Order Attribute fields
  if (formType === 'add' || showOrderAttribute) {
    fields.push({
      fieldType: 'section',
      fieldName: 'orderAttributeSection',
      label: 'Order Attribute:',
      showDivider: false,
    })

    fields.push({
      fieldType: 'text',
      fieldName: 'orderAttribute.name',
      label: 'Attribute Name',
      placeholder: 'Enter Order Attribute Name',
      defaultValue: '',
      config: {},
    })

    fields.push({
      fieldType: 'text',
      fieldName: 'orderAttribute.description',
      label: 'Description',
      placeholder: 'Enter Order Attribute Description',
      defaultValue: '',
      config: {},
    })
  }

  // Vehicle Attribute fields
  if (formType === 'add' || showVehicleAttribute) {
    fields.push({
      fieldType: 'section',
      fieldName: 'vehicleAttributeSection',
      label: 'Run Attribute:',
      showDivider: showOrderAttribute,
    })

    fields.push({
      fieldType: 'text',
      fieldName: 'vehicleAttribute.name',
      label: 'Attribute Name',
      placeholder: 'Enter Run Attribute Name',
      defaultValue: '',
      config: {},
    })

    fields.push({
      fieldType: 'text',
      fieldName: 'vehicleAttribute.description',
      label: 'Description',
      placeholder: 'Enter Run Attribute Description',
      defaultValue: '',
      config: {},
    })
  }

  // Constraint fields (only show if both attribute types are present)
  if (formType === 'add' || showCompatible) {
    fields.push({
      fieldType: 'section',
      fieldName: 'constraintSection',
      label: '',
      showDivider: true,
    })

    fields.push({
      fieldType: 'checkbox',
      fieldName: 'isCompatible',
      label: 'Compatible?',
      defaultValue: true,
      labelPlacement: 'end',
    })
  }

  const formDefinition: DynamicFormDefinition = {
    formType: 'default',
    sections: [
      {
        label: 'Attribute/Constraint Details',
        fields: fields,
      },
    ],
  }

  return formDefinition
}